import { Link } from 'react-router-dom';
import './T4Button.css';

const T4Button = ({ children, className, link, onClick, to }) => {
  return link ? (
    <Link to={to} className={'t4-button ' + (className || '')}>
      {children}
    </Link>
  ) : (
    <button className={'t4-button ' + (className || '')}>{children}</button>
  );
};

T4Button.defaultProps = {
  className: '',
  onClick: () => {},
  link: false,
  to: '',
};

export default T4Button;
